import { models, kea, fa } from "app/main/std";

type Entity = models.OrigenUsuarioApiDto;
type Column = kea.Grid2Column<Entity>;

const columnasFijas: Column[] = [
    {title: "Clave", cell:x => ({data: x.Clave})},
    {title: "Sucursal", cell:x => ({data: x.NombreSucursal})},
    {title: "Estado", cell:x => ({data: x.NombreEstado})},
    {title: "Ciudad", cell:x => ({data: x.NombreCiudad})},
    {title: "CP", cell:x => ({data: x.NombreCP})},
    {title: "Colonia", cell:x => ({data: x.NombreColonia})},
    {title: "Calle", cell:x => ({data: x.Direccion.Calle})},
    {title: "Contacto", cell:x => ({data: x.NombreContacto})},
]

export interface BotonesDeps {
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Editar",
            style: "primary",
            iconClass: fa("pencil"),
            onClick: deps.onEdit
        },
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onBorrar
        }
    ]);

    return columna;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/edit/origen/columns.tsx